import { updateSurveyProperty, deleteSurveyProperty } from './api';

export const UPDATE_SURVEY_PROPERTY = 'update_survey_property';

export function toggleReject(path, surveyProperty) {
  const updatedSurveyProperty = { ...surveyProperty };
  updatedSurveyProperty.rejected = !surveyProperty.rejected;

  return (dispatch) => {
    updateSurveyProperty(path, updatedSurveyProperty).then((response) => {
      dispatch({
        type: UPDATE_SURVEY_PROPERTY,
        payload: response.tenantRepProperty
      });
    });
  };
}

export const REMOVE_SURVEY_PROPERTY = 'remove_survey_property';

export function removeSurveyProperty(assignmentId, property) {
  return (dispatch) => {
    deleteSurveyProperty(assignmentId, property.id).then(() => {
      dispatch({ type: REMOVE_SURVEY_PROPERTY, payload: property.id });
    });
  };
}
